import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'ca',
    conver: 'en-CA',
    alia: 'en',
    region: 'Canada',
    regionText: 'Canada',
    language: 'English',
    languageText: 'English',
    appId: 4,
    acceptLanguage: 'en-CA,en;q=0.9',
};
export default theLocale;
